import { RECEIVE_PRESS_RELEASES_DATA } from "../actions/pressReleasesActions";

const initialState = {};

export default function pressReleasesReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_PRESS_RELEASES_DATA:
      return {
        ...state,
        pressReleases: [...action.payload]
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/pressReleasesReducer.js